<h3>Informações da contrapartida</h3>
<hr>

<div class="col-md-12 animated fadeIn">

  <div class="form-group">
    <label>Terá contrapartida?</label>
    <div class="radio">
      <label>
        <input type="radio" name="optionsRadios91" value="option1" checked=""> Não
      </label>
      &nbsp;&nbsp;&nbsp;
      <label>
        <input type="radio" name="optionsRadios91" value="option2"> Sim
      </label>
    </div>
  </div>

  <div class="form-group">
    <label>Se SIM qual o tipo?</label>
    <div class="radio">
      <label>
        <input type="radio" name="optionsRadios92" value="option1" checked=""> Financeiro
      </label>
      &nbsp;&nbsp;&nbsp;
      <label>
        <input type="radio" name="optionsRadios92" value="option2"> Outros
      </label>
    </div>
  </div>

  <div class="form-group col-md-3">
    <label>Valor:</label>
    <input type="text" class="form-control" placeholder="R$ 0.000,00">
  </div>

  <div class="form-group col-md-9">
    <label>Como será aplicado o recurso:</label>
    <textarea class="form-control" rows="3"></textarea>
  </div>


</div>

<br>
<br>